var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "119.07mm",
    height: "26.05mm",
    viewBox: "0 0 337.53 73.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245,417.16H212.68v15.26h16.21a17.9,17.9,0,1,1-6.82-22.89h20.06a33.16,33.16,0,0,0-55-5.9,33.16,33.16,0,0,0-43.46-6.75V384.12H128.42v40.67A33.17,33.17,0,0,0,187.14,446,33.17,33.17,0,0,0,245,417.16Zm-83.37,25.55a17.92,17.92,0,1,1,17.92-17.92A17.91,17.91,0,0,1,161.59,442.71Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#e50051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,419.73a8.79,8.79,0,0,0-4.82,1.34v-9.16h-5.87v25.73h5.87v-.91a8.79,8.79,0,0,0,4.82,1.34,9.18,9.18,0,0,0,0-18.34Zm-1.16,13.52a4.49,4.49,0,0,1-3.66-1.63v-5.44a4.55,4.55,0,0,1,3.66-1.66,4.37,4.37,0,0,1,0,8.73Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.54,420.06h-5.87v17.58h5.87v-10c1.38-1.38,3.19-2.14,6-2.25v-5.58a8.79,8.79,0,0,0-6,2.17Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.25,
    y: 35.94,
    width: 5.87,
    height: 17.58,
    fill: "#213b5e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.57,410.67A3.32,3.32,0,1,0,323,414,3.33,3.33,0,0,0,319.57,410.67Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.39,421.07a8.79,8.79,0,0,0-4.82-1.34,9.18,9.18,0,0,0,0,18.34,8.79,8.79,0,0,0,4.82-1.34v.91h5.87V411.91h-5.87Zm0,10.55a4.49,4.49,0,0,1-3.66,1.63,4.37,4.37,0,0,1,0-8.73,4.55,4.55,0,0,1,3.66,1.66Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.11,420.75a8.9,8.9,0,0,0-4.78-1.31,8.79,8.79,0,0,0,0,17.58,9.25,9.25,0,0,0,4.78-1.23v1.66a3.34,3.34,0,0,1-3.55,3.63c-2.17,0-3.4-1-3.69-2.65h-5.8c.29,4.57,4.16,7.61,9.49,7.61,5.51,0,9.42-3.19,9.42-8.69V420.06h-5.87Zm0,10a4.56,4.56,0,0,1-3.62,1.63,4.08,4.08,0,0,1-4.13-3.87,4,4,0,0,1,4.13-4.24,4.59,4.59,0,0,1,3.62,1.63Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M380.2,419.66c-5.62,0-9.35,3.84-9.35,9.17s3.84,9.2,9.6,9.2c4.35,0,7.72-2.28,8.55-5.9h-5.8a3,3,0,0,1-2.68,1.27,3.8,3.8,0,0,1-3.95-2.83h12.54l0-.11a12.08,12.08,0,0,0,.11-2C389.18,423.18,385.31,419.66,380.2,419.66Zm-3.7,7.47a3.58,3.58,0,0,1,3.7-2.94,3.25,3.25,0,0,1,3.47,2.94Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M405.27,420.75a8.9,8.9,0,0,0-4.78-1.31,8.79,8.79,0,0,0,0,17.58,9.25,9.25,0,0,0,4.78-1.23v1.66a3.35,3.35,0,0,1-3.55,3.63c-2.17,0-3.41-1-3.7-2.65h-5.79c.29,4.57,4.16,7.61,9.49,7.61,5.51,0,9.42-3.19,9.42-8.69V420.06h-5.87Zm0,10a4.56,4.56,0,0,1-3.62,1.63,4.08,4.08,0,0,1-4.13-3.87,4,4,0,0,1,4.13-4.24,4.59,4.59,0,0,1,3.62,1.63Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M427.56,421a9.17,9.17,0,1,0,0,15.66v1h5.87V420.06h-5.87Zm0,10.55a4.52,4.52,0,0,1-3.66,1.63,4.38,4.38,0,0,1,0-8.74,4.56,4.56,0,0,1,3.66,1.67Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M447.38,419.66a8.82,8.82,0,0,0-4.82,1.34v-.94h-5.87v25.73h5.87v-9.13a9.09,9.09,0,1,0,4.82-17Zm-1.16,13.52a4.52,4.52,0,0,1-3.66-1.63v-5.44a4.56,4.56,0,0,1,3.66-1.67,4.38,4.38,0,0,1,0,8.74Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M462.66,426.24A3.29,3.29,0,1,1,466,423,3.29,3.29,0,0,1,462.66,426.24Zm0-5.88a2.59,2.59,0,1,0,2.59,2.59A2.6,2.6,0,0,0,462.66,420.36Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M463.35,424.26l-.53-.8h-.65v.8h-.53v-2.62h1.13c.66,0,1.08.35,1.08.9a.84.84,0,0,1-.43.76l-.07,0,.62.92ZM462.17,423h.59a.46.46,0,1,0,0-.9h-.59Z",
    transform: "translate(-128.42 -384.12)",
    fill: "#213b5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.e5ef075e2a9b431865e972ebb165d362.svg";
export { ForwardRef as ReactComponent };